import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useAuthStore } from "@/store/authStore";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Preface from "@/pages/Preface";
import Boutique from "@/pages/Boutique";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Orders from "@/pages/Orders";
import Profile from "@/pages/Profile";
import PsService from "@/pages/ps/PsService";
import PsServiceDetail from "@/pages/ps/PsServiceDetail";
import PsCart from "@/pages/ps/PsCart";
import PsDelivery from "@/pages/ps/PsDelivery";
import PsCheckout from "@/pages/ps/PsCheckout";
import PsTracking from "@/pages/ps/PsTracking";
import RootConsole from "@/pages/RootConsole";
import InsightsCockpit from "@/pages/InsightsCockpit";
import FounderCockpit from "@/pages/FounderCockpit";
import FounderFormules from "@/pages/FounderFormules";
import FounderPreface from "@/pages/FounderPreface";
import Tyluss from "@/pages/Tyluss";
import RestaurantBoissons from "@/pages/RestaurantBoissons";
import UniverseCatalog from "@/pages/UniverseCatalog";
import ParcelService from "@/pages/ParcelService";
import CourierSpace from "@/pages/CourierSpace";
import CourierSettings from "@/pages/CourierSettings";
import MaisonMenu from "@/pages/MaisonMenu";
import PartnerRestaurant from "@/pages/PartnerRestaurant";
import PartnerManage from "@/pages/PartnerManage";
import Partenariat from "@/pages/Partenariat";
import PartnerApplications from "@/pages/PartnerApplications";
import DriverApplications from "@/pages/DriverApplications";
import Favoris from "@/pages/Favoris";
import HomeServices from "@/pages/HomeServices";

const withLayout = (el) => <Layout>{el}</Layout>;
const protectedLayout = (el) => <ProtectedRoute>{withLayout(el)}</ProtectedRoute>;

function App() {
  const loadToken = useAuthStore((s) => s.loadToken);
  const [ready, setReady] = useState(false);

  useEffect(() => { loadToken(); setReady(true); }, [loadToken]);
  if (!ready) return null;

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/tuluss-root" element={<RootConsole />} />

          <Route path="/" element={<Preface />} />
          <Route path="/accueil" element={<Navigate to="/" replace />} />
          <Route path="/univers/:key" element={withLayout(<UniverseCatalog />)} />
          <Route path="/services/colis" element={withLayout(<ParcelService />)} />
          <Route path="/livreur" element={withLayout(<CourierSpace />)} />
          <Route path="/gestion/livraison-colis" element={withLayout(<CourierSettings />)} />
          <Route path="/boutique" element={withLayout(<Boutique />)} />
          <Route path="/boutique/:handle" element={withLayout(<Boutique />)} />
          <Route path="/produit/:id" element={withLayout(<ProductDetail />)} />
          <Route path="/restaurant-boissons" element={withLayout(<RestaurantBoissons />)} />
          <Route path="/restaurant-boissons/menu" element={withLayout(<MaisonMenu />)} />
          <Route path="/restaurant/:id" element={withLayout(<PartnerRestaurant />)} />
          <Route path="/restaurant-partenaire" element={protectedLayout(<PartnerManage />)} />
          <Route path="/partenariat" element={withLayout(<Partenariat />)} />
          <Route path="/founder/partenaires" element={protectedLayout(<PartnerApplications />)} />
          <Route path="/founder/livreurs" element={protectedLayout(<DriverApplications />)} />
          <Route path="/founder/rendement" element={protectedLayout(<InsightsCockpit />)} />
          <Route path="/founder/supervision" element={protectedLayout(<FounderCockpit />)} />
          <Route path="/founder/formules" element={protectedLayout(<FounderFormules />)} />
          <Route path="/founder/preface" element={protectedLayout(<FounderPreface />)} />
          <Route path="/panier" element={withLayout(<Cart />)} />

          <Route path="/checkout" element={protectedLayout(<Checkout />)} />
          <Route path="/commandes" element={protectedLayout(<Orders />)} />
          <Route path="/profil" element={protectedLayout(<Profile />)} />
          <Route path="/favoris" element={protectedLayout(<Favoris />)} />
          <Route path="/services-domicile" element={protectedLayout(<HomeServices />)} />
          <Route path="/tyluss" element={protectedLayout(<Tyluss />)} />

          <Route path="/personal-shopper" element={protectedLayout(<PsService />)} />
          <Route path="/personal-shopper/panier" element={protectedLayout(<PsCart />)} />
          <Route path="/personal-shopper/livraison" element={protectedLayout(<PsDelivery />)} />
          <Route path="/personal-shopper/checkout" element={protectedLayout(<PsCheckout />)} />
          <Route path="/personal-shopper/suivi/:token" element={protectedLayout(<PsTracking />)} />
          <Route path="/personal-shopper/:stop" element={protectedLayout(<PsServiceDetail />)} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
